import React from 'react';
import {
  Card, Grid, Theme, Typography,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useTranslation } from '@gamiphy/react-i18n';
import { ThemeStore } from '@gamiphy/loyalty-station-desktop/store/theme';
import CashbackIcon from '@gamiphy/icons/CashbackIcon';

const useStyles = makeStyles<Theme>((theme) => ({
  root: {
    boxShadow: 'none',
    width: '100%',
    paddingBottom: theme.spacing(2),
  },
  description: {
    fontSize: '1.2rem',
    fontWeight: 500,
    lineHeight: 1.25,
  },
}));

export type Props = {
  currentCashBack: number,
}

const CashbackMission: React.FC<Props> = ({ currentCashBack }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Card className={classes.root}>
      <Grid
        container
        direction="row"
        alignItems="center"
        wrap="nowrap"
        columnSpacing={1}
      >
        <Grid item>
          <CashbackIcon width="24px" height="24px" textColor={ThemeStore.theme?.palette?.primary?.main} />
        </Grid>
        <Grid item>
          <Typography className={classes.description}>
            {t('mission.cashback.description', {
              defaultValue: 'Make a purchase and get {{currentCashBack}}% back in points',
              currentCashBack,
            })}
          </Typography>
        </Grid>
      </Grid>
    </Card>
  );
};

export default CashbackMission;
